import { TourOrderByEnum, OrderByDirectionEnum } from "../../../store";

export interface IToursSectionState {
    toursTotal: number
    orderBy: TourOrderByEnum
    orderByDirection: OrderByDirectionEnum
    showCategories: boolean
    showMap: boolean
    showSortMenu: boolean
}

export interface IToursSectionStoreAction {
    type: EToursSectionStateActionTypes
    toursTotal?: number
    orderBy?: TourOrderByEnum
    orderByDirection?: OrderByDirectionEnum
    showCategories?: boolean
    showMap?: boolean
    showSortMenu?: boolean
}

export type ToursSectionStoreDispatchAction = (action: IToursSectionStoreAction) => void

export enum EToursSectionStateActionTypes {
    SetToursTotal,
    SetOrderBy,
    SetOrderByDirection,
    ToggleOrderByDirection,
    SetShowCategories,
    ToggleShowCategories,
    SetShowMap,
    ToggleShowMap,
    SetShowSortMenu
}